import { render } from "./VerifyEmailForm.vue?vue&type=template&id=7099947e"
import script from "./VerifyEmailForm.vue?vue&type=script&lang=js"
export * from "./VerifyEmailForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__